import React from "react";
import InputField from "../../SharedComponent/Fields/InputField";
import BookValueHistory from "../common/BookValueHistory";

const FinancialInfoSection = ({
  t,
  newAsset,
  handleChange,
  showPublish = false,
  id
}) => (
  <>
    <div className="mb-6 bg-white p-4 shadow-md">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        {t("assetPageHeadings.pricingInformation")}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        <div>
          <InputField
            name="end_user_price"
            type="number"
            step="0.01"
            value={newAsset.end_user_price}
            onChange={handleChange}
            label={t("createAsset.placeholders.endUserPriceLabel")}
            explanation={t("createAsset.placeholders.endUserPriceExplanation")}
            placeholder={t("createAsset.placeholders.endUserPricePlaceholder")}
            maxLength={12}
          />
        </div>
        <div>
          <InputField
            name="dealer_price"
            type="number"
            step="0.01"
            value={newAsset.dealer_price}
            onChange={handleChange}
            label={t("createAsset.placeholders.dealerPriceLabel")}
            explanation={t("createAsset.placeholders.dealerPriceExplanation")}
            placeholder={t("createAsset.placeholders.dealerPricePlaceholder")}
            maxLength={12}
          />
        </div>
        <div>
          <InputField
            name="internal_price"
            type="number"
            step="0.01"
            value={newAsset.internal_price}
            onChange={handleChange}
            label={t("createAsset.placeholders.internalPriceLabel")}
            explanation={t("createAsset.placeholders.internalPriceExplanation")}
            placeholder={t("createAsset.placeholders.internalPricePlaceholder")}
            maxLength={12}
          />
        </div>
        {/* {showPublish && ( */}
        <div className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2 flex flex-col sm:flex-row sm:items-center sm:space-x-4 space-y-2 sm:space-y-0 w-full">
          <span className="text-sm font-medium text-gray-700">
            {t("createAsset.placeholders.publishTo")}
          </span>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
            <label className="flex items-center space-x-1">
              <input
                type="checkbox"
                name="publish_mascus"
                checked={newAsset.publish_mascus || false}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-sm text-gray-700">Mascus</span>
            </label>
            <label className="flex items-center space-x-1">
              <input
                type="checkbox"
                name="publish_supralift"
                checked={newAsset.publish_supralift || false}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-sm text-gray-700">Supralift</span>
            </label>
            <label className="flex items-center space-x-1">
              <input
                type="checkbox"
                name="publish_forklift"
                checked={newAsset.publish_forklift || false}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-sm text-gray-700">Forklift</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    {/* Rental Pricing Section */}
    <div className="mb-8 bg-white p-4 shadow-md">
      <h4 className="text-md font-medium text-gray-700 mb-4">
        {t("assetPageHeadings.rentingPriceInformation")}
      </h4>

      {/* Rental Pricing Grid - Responsive Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
        <div>
          <InputField
            name="rental_price_daily"
            type="number"
            step="0.01"
            value={newAsset.rental_price_daily}
            onChange={handleChange}
            label={t("createAsset.placeholders.rentalPriceDailyLabel")}
            explanation={t(
              "createAsset.placeholders.rentalPriceDailyExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.rentalPriceDailyPlaceholder"
            )}
            maxLength={12}
          />
        </div>

        <div>
          <InputField
            name="rental_price_weekly"
            type="number"
            step="0.01"
            value={newAsset.rental_price_weekly}
            onChange={handleChange}
            label={t("createAsset.placeholders.rentalPriceWeeklyLabel")}
            explanation={t(
              "createAsset.placeholders.rentalPriceWeeklyExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.rentalPriceWeeklyPlaceholder"
            )}
            maxLength={12}
          />
        </div>

        <div>
          <InputField
            name="rental_price_monthly"
            type="number"
            step="0.01"
            value={newAsset.rental_price_monthly}
            onChange={handleChange}
            label={t("createAsset.placeholders.rentalPriceMonthlyLabel")}
            explanation={t(
              "createAsset.placeholders.rentalPriceMonthlyExplanation"
            )}
            placeholder={t(
              "createAsset.placeholders.rentalPriceMonthlyPlaceholder"
            )}
            maxLength={12}
          />
        </div>
      </div>
    </div>

    {/* Purchase Information Section */}
    <div className="mb-8 bg-white p-4 shadow-md">
      <h4 className="text-md font-medium text-gray-700 mb-4">
        {t("createAsset.placeholders.purchaseInformation")}
      </h4>

      {/* Purchase Information Grid - Responsive Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
        <div>
          <InputField
            name="purchase_price"
            type="number"
            step="0.01"
            value={newAsset.purchase_price}
            onChange={handleChange}
            label={t("createAsset.placeholders.purchasePriceLabel")}
            explanation={t("createAsset.placeholders.purchasePriceExplanation")}
            placeholder={t("createAsset.placeholders.purchasePricePlaceholder")}
            maxLength={12}
          />
        </div>

        <div>
          <InputField
            name="purchase_date"
            type="date"
            value={newAsset.purchase_date || ""}
            onChange={handleChange}
            label={t("createAsset.placeholders.dateOfPurchaseLabel")}
            explanation={t(
              "createAsset.placeholders.dateOfPurchaseExplanation"
            )}
          />
        </div>

        <div>
          <InputField
            name="book_value"
            type="number"
            step="0.01"
            value={newAsset.book_value}
            onChange={handleChange}
            label={t("createAsset.placeholders.bookValueLabel")}
            explanation={t("createAsset.placeholders.bookValueExplanation")}
            placeholder={t("createAsset.placeholders.bookValuePlaceholder")}
            maxLength={12}
          />
        </div>
      </div>
    </div>

    <BookValueHistory t={t} id={id} />

    {/* Remarks Section */}
    <div className="mb-8 bg-white p-4 shadow-md">
      <h4 className="text-md font-medium text-gray-700 mb-4">
        {t("createAsset.placeholders.Remarks")}
      </h4>

      {/* Remarks Grid - Responsive Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <div className="mb-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("createAsset.placeholders.internalRemark")}
          </label>
          <textarea
            name="internal_remark"
            value={newAsset.internal_remark || ""}
            onChange={handleChange}
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
            placeholder={t(
              "createAsset.placeholders.internalRemarkPlaceholder"
            )}
          />
          <p className="text-xs text-gray-500 mt-1">
            {t("createAsset.placeholders.internalRemarkForAsset")}
          </p>
        </div>

        <div className="mb-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("createAsset.placeholders.intranetRemarks")}
          </label>
          <textarea
            name="intranet_remark"
            value={newAsset.intranet_remark || ""}
            onChange={handleChange}
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical"
            placeholder={t(
              "createAsset.placeholders.intranetRemarksPlaceholder"
            )}
          />
          <p className="text-xs text-gray-500 mt-1">
            {t("createAsset.placeholders.intranetRemarksForAsset")}
          </p>
        </div>
      </div>
    </div>
  </>
);

export default FinancialInfoSection;
